import objHash from 'object-hash';

export function enumToDisplayCase(str: string) {
  return str
    .toLowerCase()
    .replace(/(^|_)./g, (s) => s.replace('_', ' ').toUpperCase());
}

export type PatchResult<T> = {
  update: T[];
  remove: T[];
  add: T[];
};

export function getPatch<T extends {} | null>(
  prev: T[],
  next: T[],
  hash: (item: T) => string | void,
  isUpdated: (prev: T, next: T) => boolean = (prev, next) => {
    return objHash(prev) !== objHash(next);
  },
): PatchResult<T> {
  const res: PatchResult<T> = { add: [], remove: [], update: [] };
  const pt = prev.reduce<{ [hash: string]: T }>((acc, item) => {
    const h = hash(item);
    if (!h) res.remove.push(item);
    else acc[h] = item;
    return acc;
  }, {});
  const nt = next.reduce<{ [hash: string]: T }>((acc, item) => {
    const h = hash(item);
    if (!h) res.add.push(item);
    else acc[h] = item;
    return acc;
  }, {});

  new Set([...Object.keys(pt), ...Object.keys(nt)]).forEach((hash) => {
    const p = pt[hash];
    const n = nt[hash];

    if (p && !n) res.remove.push(p);
    else if (!p && n) res.add.push(n);
    else if (isUpdated(p, n)) res.update.push(n);
  });
  return res;
}
